import {store} from "../store/store";

export function permissionIsGranted(organisation_id:number|undefined, permission: string)
{
    if (permission === "ADMIN" || permission === "ROLE_ADMIN")
    {
        return store.getState().user.roles.includes("ROLE_ADMIN")
    }
    if (permission === "COMMERCIAL" || permission === "ROLE_COMMERCIAL")
    {
        return store.getState().user.roles.includes("ROLE_COMMERCIAL")
    }

    if (typeof organisation_id === "undefined") {
        return store.getState().user.roles.includes("ROLE_ADMIN") //False
    }

    let orga = store.getState().organisation.list.filter(o => o.id === organisation_id)[0]
    if (typeof orga === "undefined" || typeof orga.permissions === "undefined") return false

    return orga.permissions.includes(permission);
}